module.exports = __webpack_public_path__ + "static/media/adrianna.211591b4.png";